<router-outlet></router-outlet>
<app-lolly-spinning-loader
	[rotating]="true"
	*ngIf="isShowingRouteLoadIndicator"
></app-lolly-spinning-loader>
<div data-mobile-detector></div>
<app-toast-v2></app-toast-v2>

<!--
	The tooltip carries the label only while the rail is collapsed, because that
	is the only state where the label is not already written under the face. A
	tooltip that repeats what is on screen is noise.
-->
<div
	class="calendly-widget"
	*ngIf="showCalendlyWidget"
	[matTooltip]="(railCollapsed$ | async) ? 'Book a Call' : ''"
	matTooltipPosition="right"
	(click)="bookADemo()"
>
	<div class="calendly-icon">
		<img src="assets/home/katy-book-a-demo.png" />
	</div>

	<button
		secondary
		class="book-a-call-button"
		borderRadiusSize="small"
		size="extra-small"
		backgroundColor="#fff"
	>
		Book a Call
	</button>
</div>
